<template>
  <tab-page-template>
    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        プロファイル照会
      </v-toolbar-title>
    </template>

    <template #tab-items>
      <v-tab :to="{name: tabRoute('/customers')}">事業者プロファイル</v-tab>
      <v-tab :to="{name: tabRoute('/dataProfiles')}">データプロファイル</v-tab>
      <v-tab :to="{name: tabRoute('/publicTradeContracts')}">募集中の取引契約</v-tab>
    </template>

    <template #after-tabs>
      <router-view></router-view>
    </template>
  </tab-page-template>
</template>

<script>
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";
import {IoableParentPageMixin} from "@/router/IoablePageMixin";
export default {
  name: "ProfileSearch",
  components: {TabPageTemplate},
  mixins: [IoableParentPageMixin],
  methods: {
    tabRoute(name) {
      return `/profileSearch${name}`;
    }
  }
}
</script>

<style scoped>

</style>
